module.exports = __webpack_public_path__ + "img/new_CTA_Cloud.1310cace.gif";